"use strict";

exports.__esModule = true;
exports.filterDevicesByTag = filterDevicesByTag;
exports.filterDevicesByTags = filterDevicesByTags;
exports.filterDevicesByUUIDs = filterDevicesByUUIDs;
exports.getDeviceByName = getDeviceByName;
exports.getDeviceByUUID = getDeviceByUUID;
exports.getValidDeviceList = getValidDeviceList;
/**
 * Get valid devices from a global deviceUuidList
 */
function getValidDeviceList(deviceQueryList, globalDeviceUuidList) {
  return deviceQueryList.filter(function (device) {
    return globalDeviceUuidList.includes(device);
  });
}

/**
 * Get a device from a list using the device uuid.
 * @throw {Error} if no such device can be found.
 */
function getDeviceByUUID(devices, uuid) {
  for (var i = 0; i < devices.length; i++) {
    var device = devices[i];
    if (device.uuid === uuid) {
      return device;
    }
  }
  throw new Error("Cannot find a device with uuid: " + uuid);
}

/**
 * Get a device from a list using the device name.
 * @throw {Error} if no such device can be found.
 */
function getDeviceByName(devices, name) {
  for (var i = 0; i < devices.length; i++) {
    var device = devices[i];
    if (device.name === name) {
      return device;
    }
  }
  throw new Error("Cannot find a device with name: " + name);
}

/**
 * Get a list of devices from another list, using an
 * array of uuids to lookup.
 */
function filterDevicesByUUIDs(devices, uuids) {
  var filtered = new Array(uuids.length);
  for (var i = 0; i < uuids.length; i++) {
    filtered[i] = getDeviceByUUID(devices, uuids[i]);
  }
  return filtered;
}

/**
 * Get a list of devices from a device list using a device tag.
 * @throw {Error} if no such device can be found.
 */
function filterDevicesByTag(devices, tag) {
  var filtered = [];
  for (var i = 0; i < devices.length; i++) {
    var device = devices[i];
    for (var j = 0; j < device.tags.length; j++) {
      if (device.tags[j] === tag) {
        filtered.push(device);
        break;
      }
    }
  }
  return filtered;
}

/**
 * Get a list of devices from another list, using an
 * array of device tags to lookup.
 */
function filterDevicesByTags(devices, tags) {
  var filtered = [];
  for (var i = 0; i < devices.length; i++) {
    var device = devices[i];
    // eslint-disable-next-line no-labels
    outer: for (var j = 0; j < device.tags.length; j++) {
      for (var k = 0; k < tags.length; k++) {
        if (device.tags[j] === tags[k]) {
          filtered.push(device);
          // eslint-disable-next-line no-labels
          break outer;
        }
      }
    }
  }
  return devices;
}